import React from 'react'
import { TableExpandableCellProps } from './TableExpandableCell.types'
// import cl from 'classnames'
import { EntityCount, Text1 } from '@touche-lts/panel-ui/dist'
import { getObjectName } from './TableExpandableCell.utils'
import { ExpandButton } from '../ExpandButton'

const TableExpandableCellComponent = (props: TableExpandableCellProps) => {
  const { objects, entityName, disabled, onClick, isExpanded } = props

  if (!objects || !objects.length) {
    return <EntityCount count={0} entity={entityName} />
  }

  if (objects.length === 1) {
    return <Text1 overflowEllipsis>{getObjectName(objects[0])}</Text1>
  }

  return (
    <>
      <ExpandButton
        preset='icon'
        disabled={disabled}
        onClick={onClick}
        isExpanded={isExpanded}
      />
      <EntityCount count={objects.length} entity={entityName} />
    </>
  )
}

const TableExpandableCell = TableExpandableCellComponent
export { TableExpandableCell }
